// extracted by mini-css-extract-plugin
export var carrierIcon = "_xr-0";
export var carrierLogo = "_xr-1";
export var detailsSection = "_xr-2";